import type { FC } from 'react';
import { useEffect } from 'react';
import WarningIcon from 'components/atoms/SVG/WarningIcon.component';
import { useBEFinSessionUI } from 'hooks/useBEFinSession';
import useUnopenedDocsUI from 'hooks/useUnopenedDocsUI';
import Dot from './Dot';
import { useIsBEFinFeatureEnabled } from 'utils/docsRepo/useIsBEFinFeatureEnabled/useIsBEFinFeatureEnabled';

const DocsRepoCount: FC<{ isActive?: boolean }> = ({ isActive }) => {
  const isFeatureEnabled = useIsBEFinFeatureEnabled();

  const { isSessionExpired } = useBEFinSessionUI();
  const { unopenedDocsCount, resetUnopenedDocs } = useUnopenedDocsUI();

  // Reset unopened docs when user visits the repository page
  useEffect(() => {
    if (isActive) {
      resetUnopenedDocs();
    }
  }, [isActive, resetUnopenedDocs]);

  // Don't show any indicators when on the repository page or feature is not enabled
  if (isActive || !isFeatureEnabled) return null;

  // Priority 1: Show warning icon if session expired
  if (isSessionExpired) {
    return (
      <WarningIcon className="text-[#DC2626] w-5 h-5 ml-1.5 inline-block" />
    );
  }

  // Priority 2: Show red dot if there are unopened documents
  if (unopenedDocsCount > 0) {
    return <Dot className="bg-[#F87171] ml-1.5 inline-block" />;
  }

  // No indicators to show
  return null;
};

export default DocsRepoCount;
